import Health from './listing/health/health';
import PlatformActions from './listing/listing-platform-actions/platformActions';
import ListingsRowActions from './listing/listing-row-actions/listing-row-actions';
import LocationSelect from './post-listing/location-select/location-select';
import ManageQuota from './manage-quota/ManageQuota';
import PostListingPage from './post-listing/post-listing';
import ListingsPage from './listing/listings';
import ListingCard from './listing/listingCard';
import PropShop from './prop-shop/prop-shop';
import BuyBundles from './buy-bundles/buy-bundles';
import BundleOrderSummary from './buy-bundles/BundleOrderSummary';
import { assignDefaultValueToObject } from '../../../utility/utility';
import UpgradeListingPage from './upgrade-listing/upgrade-listing';
import ListingsSummary from './reports/ListingsSummary';
import { Logo } from './logo/Logo';
import InboxPage from './inbox/inbox-container';
import UserPreferencePage from './preference/preference';
import { QuotaCreditModal } from './listing/listing-platform-actions/quotaCreditModal';
import BundleDiscountModal from './bundle-discount-modal/BundleDiscountModal';

let Components = {
  PostListingPage,
  PlatformActions,
  ListingsRowActions,
  LocationSelect,
  ManageQuota,
  ListingsPage,
  Health,
  PropShop,
  BuyBundles,
  BundleOrderSummary,
  UpgradeListingPage,
  ListingCard,
  ListingsSummary,
  Logo,
  InboxPage,
  UserPreferencePage,
  QuotaCreditModal,
  BundleDiscountModal,
};

export default assignDefaultValueToObject(Components, () => null);
